import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { styleTags, tags as t } from '@lezer/highlight';

import { parser } from './arista-parser.js';

const aristaLanguage = LRLanguage.define({
  parser: parser.configure({
    props: [
      styleTags({
        version: t.propertyName,
        VersionNumber: t.string,
        no: t.keyword,
        description: t.propertyName,
        DescriptionText: t.string,
        'PropertyName/Identifier': t.propertyName,
        'Value/Identifier': t.variableName,
        Number: t.number,
        'IpPrefix/Number': t.number,
        'Ipv6Prefix/Number': t.number,
        String: t.string,
        IpAddress: t.atom,
        Ipv6Address: t.atom,
        '"/"': t.operator,
        LineComment: t.lineComment,
        BlockComment: t.blockComment,
        '{ }': t.brace,
        '[ ]': t.squareBracket,
        ';': t.separator
      })
    ]
  }),
  languageData: {
    commentTokens: { line: '#' },
    wordChars: '-_./:'
  }
});

export function arista() {
  return new LanguageSupport(aristaLanguage);
}

export { aristaLanguage };
